<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        {{data.action | titlecase }} {{ type }}
    </div>
    <div>
        <mat-icon mat-dialog-close [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <div class="grid grid-cols-1 gap-2">
        <div class="w-full" *ngIf="isCreate">
            <mat-form-field class="w-full" floatLabel="always">
                <mat-label>Well String</mat-label>
                <input type="text" placeholder="Enter Well String Name" aria-label="Number" matInput
                    [matAutocomplete]="stringName" (keyup)="onAutocomplete()" [(ngModel)]="wellStringName" #wellStringNameModel="ngModel"
                    (blur)="validateSelection()" required/>

                <!-- Suffix Icon -->
                <button mat-icon-button matSuffix>
                    <mat-icon svgIcon="mat_solid:arrow_drop_down"></mat-icon>
                </button>

                <mat-autocomplete #stringName="matAutocomplete" (optionSelected)="onSelected()">
                    <mat-option *ngFor="let row of options.wellStrings" [value]="row.stringShortName"
                        [disabled]=" row.stringShortName == 'Not Found'">
                        {{ row.stringShortName }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="wellStringNameModel.hasError('required')">Well String is required</mat-error>
            </mat-form-field>
        </div>

        <div class="w-full">
            <mat-form-field class="w-full">
                <mat-label>Plan Date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="payload.planDate" #planDateModel="ngModel" readonly required/>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="planDateModel.hasError('required')">Plan Date is required</mat-error>
            </mat-form-field>
        </div>

        <div class="w-full">
            <mat-form-field class="w-full">
                <mat-label>Remark</mat-label>
                <textarea matInput [(ngModel)]="payload.remark" rows="4"></textarea>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary" (click)="save()"
        [disabled]="!payload.wellStringId || !payload.planDate">Save</button>
</mat-dialog-actions>